import React from "react";
import { ITeaserListProps } from "./TeaserListProps";
import { StyledContainer, Teaser, TeaserCards } from "./TeaserListHelpers";
import { Row } from "react-bootstrap";

const TeaserList: React.FC<ITeaserListProps> = (props) => {
  const teasers = props.relationships
    ? props.relationships.field_teaser_blocks || null
    : null;
  const teaserCount = teasers ? teasers.length : 0;
  const columnWidth = teaserCount === 2 ? 6 : 4;
  return (
    <StyledContainer>
      {(props.field_subtitle ||
        props.field_title ||
        props.field_link ||
        props.field_description) && <Teaser {...props} />}
      {teasers && (
        <Row>
          {teasers.map((teaser, idx) => {
            return (
              <TeaserCards
                teaserId={idx + 1}
                key={`teaser-cards-${idx}`}
                columnWidth={columnWidth}
                teaser={teaser}
                backgroundColor={props.backgroundColor}
              />
            );
          })}
        </Row>
      )}
    </StyledContainer>
  );
};

export default TeaserList;
